export const SET_LOGIN_FORM_FIELD = 'SET_LOGIN_FORM_FIELD'
export const SET_LOGIN_FORM = 'SET_LOGIN_FORM'
